import { sendPost } from '@utils/request';

// 生日汇首页数据
export function getHomePageData(data) {
  const url = 'trade/birthdayContract/getHomePageData';
  return sendPost({ url, data });
}

// 品牌详情数据
export function getBrandDetailData(data) {
  const url = '/trade/birthdayContract/getBrandDetails';
  return sendPost({ url, data });
}

// 随心兑品牌小程序码
export function getBrandAppletsCode(data) {
  const url = '/wechat/brand/appletsCode';
  return sendPost({ url, data });
}

